import React from "react";
import './learnmore.css'

const learnMoreData = [
    {statNumber : 297, contentText: "coursiers à vélo ont démarré leur activité grâce à LegalPlace"},
    {statNumber : "97%", contentText: "de satisfaction clients"}
]

const LearnMoreItem = ({statNumber, contentText}) => (
    <div className="learnmore_card">
        <div className="learnmore_card_title">{statNumber}</div> 
        <div className="learnmore_card_text">{contentText}</div>
    </div>
)

const LearnMore = () => (
<div className="learnmore_wrapper">
    <h3 className="learnmore_title">En savoir plus sur Legalplace</h3>
    <div className="learnmore_cards_wrapper">
    {
        learnMoreData.map((blocElement, index) => {
            const { statNumber, contentText } = blocElement
            return (
                <LearnMoreItem
                    statNumber={statNumber}
                    contentText={contentText}
                    key={`learnMoreItem_${index + 1}`}
                />
                )
        })
    }
    </div>
</div>
)

export default LearnMore;



// WEBPACK FOOTER //
// ./src/components/buy/Checkout/LearnMore.js